/**
 * Get user object from the environment
 */
export function getUser(hasOptedOut) {
    let externalUid, userIds = [];
    if (hasOptedOut) {
        return {};
    }
    ;
    externalUid = (document.cookie.match(/MUID=([^;$]+)/) || [])[1];
    if (!externalUid) {
        return {};
    }
    return { externalUid, userIds: [{ type: 'extendedIDs', eids: [{ id: externalUid, source: 'msft_muid' }] }] };
}
